import { Avatar, HStack, Icon, Image, Text, VStack } from "@chakra-ui/react";
import { CheckCircle, XCircle } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Container from "../components/Container";
import Footer from "../components/Footer";
import Nav from "../components/nav/Nav";
import ComponentSpinner from "../components/spinner/ComponentSpinner";
import cr from "../lib/request";

export default function VerifyCertificate() {
  const [loading, setLoading] = useState<boolean>(true);
  const [verified, setVerified] = useState<boolean>(false);
  const [data, setData] = useState<any | null>(null);
  const { publicId } = useParams();

  useEffect(() => {
    setLoading(true);
    const url = `api/course/verify-certificate/${publicId}`;
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          console.log(r.data.data);
          setVerified(true);
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
        setVerified(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <VStack gap={0} minH={"100vh"}>
      <Nav />

      <Container flex={1}>
        <VStack px={10} py={10} pb={16} justify={"center"} flex={1}>
          {loading && <ComponentSpinner flex={1} />}

          {!loading && !verified && (
            <>
              <Icon
                as={XCircle}
                fontSize={150}
                weight={"thin"}
                color={"p.500"}
              />
              <Text
                fontSize={32}
                fontWeight={600}
                color={"p.500"}
                textAlign={"center"}
              >
                Sertifikat Anda Tidak Asli
              </Text>
              <Text fontSize={20} textAlign={"center"}>
                Silahkan bergabung dan selesaikan course di course.kubu.id
              </Text>
            </>
          )}

          {!loading && verified && data && (
            <>
              <Icon
                as={CheckCircle}
                fontSize={150}
                weight={"thin"}
                color={"p.500"}
              />
              <Text
                fontSize={32}
                fontWeight={600}
                color={"p.500"}
                textAlign={"center"}
              >
                Sertifikat Anda Terverifikasi
              </Text>

              <Text mb={4} fontSize={18}>
                {data.certificate.public_id}
              </Text>

              <Text mb={12}>
                Didapatkan pada tanggal : <b>{data.completed_at}</b>
              </Text>

              <VStack align={"center"} w={"100%"} mb={8}>
                <HStack
                  align={"flex-start"}
                  gap={8}
                  p={6}
                  border={"1px solid var(--divider3)"}
                  borderRadius={12}
                  flexDir={["column", null, "row"]}
                >
                  <VStack minW={"300px"} gap={4} align={"stretch"}>
                    {/* <Avatar name={data.name} src={data.image} size={"lg"} /> */}
                    <Text fontWeight={500}>Diberikan kepada</Text>

                    <VStack align={"stretch"}>
                      <Avatar
                        name={data.user.name}
                        src={data.user.image}
                        mb={4}
                        size={"lg"}
                      />

                      <HStack>
                        <Text opacity={0.6} w={"100px"}>
                          Nama
                        </Text>
                        <Text fontWeight={500} noOfLines={1}>
                          {data.user.name}
                        </Text>
                      </HStack>

                      <HStack>
                        <Text opacity={0.6} w={"100px"}>
                          Username
                        </Text>
                        <Text noOfLines={1}>{data.user.username}</Text>
                      </HStack>

                      <HStack>
                        <Text opacity={0.6} w={"100px"}>
                          Email
                        </Text>
                        <Text noOfLines={1}>{data.user.email}</Text>
                      </HStack>

                      <HStack>
                        <Text opacity={0.6} w={"100px"}>
                          Telepon
                        </Text>
                        <Text noOfLines={1}>{data.user.phone}</Text>
                      </HStack>
                    </VStack>
                  </VStack>

                  <VStack gap={4} align={"flex-start"} maxW={"300px"}>
                    <Image
                      src={`${process.env.REACT_APP_MEDIA_BASE_URL}${data.course.image}`}
                      borderRadius={8}
                      objectFit={"cover"}
                      aspectRatio={"16/9"}
                      // h={"120px"}
                      w={"100%"}
                      // mb={4}
                    />

                    <VStack align={"stretch"} px={2} gap={0}>
                      <Text
                        fontSize={20}
                        fontWeight={600}
                        lineHeight={1.3}
                        mb={2}
                      >
                        {data.course.nama_course}
                      </Text>

                      <Text opacity={0.6}>{data.course.total_duration}</Text>
                      <Text opacity={0.6}>{data.total_silabus} Video</Text>
                    </VStack>
                  </VStack>
                </HStack>
              </VStack>
            </>
          )}
        </VStack>
      </Container>

      <Footer />
    </VStack>
  );
}
